import React from "react";
import { Box, TextField, Switch } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

interface FilterValueInputProps {
    type: string;
    value: any;
    index: number;
    setComboFilters: (filters: any[]) => void;
    comboFilters: any[];
    openDatePickerIndex: number | null;
    setOpenDatePickerIndex: (index: number | null) => void;
    myStylePickers?: any;
    disableKeyboardEntry?: (event: React.FormEvent<HTMLInputElement>) => void;
    t: (key: string) => string;
}

export const FilterValueInput: React.FC<FilterValueInputProps> = ({
    type,
    value,
    index,
    setComboFilters,
    comboFilters,
    openDatePickerIndex,
    setOpenDatePickerIndex,
    myStylePickers,
    disableKeyboardEntry,
    t,
}) => {
    switch (type) {
        case "date":
            return (
                <DatePicker
                    open={openDatePickerIndex === index}
                    onClose={() => setOpenDatePickerIndex(null)}
                    label={t("filter.fields.value")}
                    onChange={(values: any) => {
                        const updatedFilters = [...comboFilters];
                        if (values !== null) {
                            let date = values?.toDate();
                            updatedFilters[index].value = date.toJSON();
                            setComboFilters(updatedFilters);
                        } else {
                            setOpenDatePickerIndex(null);
                        }
                    }}
                    sx={{ paddingRight: 0.5 }}
                    slotProps={{
                        popper: {
                            sx: myStylePickers,
                        },
                        textField: {
                            variant: "filled",
                            size: "small",
                            fullWidth: true,
                            onClick: () => setOpenDatePickerIndex(index),
                            onBeforeInput: disableKeyboardEntry,
                        },
                    }}
                    format="DD/MM/YYYY"
                    defaultValue={dayjs(value)}
                />
            );
        case "boolean":
            return (
                <Box display="flex" justifyContent="center" alignItems="center">
                    <Switch
                        onChange={(event) => {
                            const updatedFilters = [...comboFilters];
                            updatedFilters[index].value = event.target.checked.toString();
                            setComboFilters(updatedFilters);
                        }}
                        defaultChecked={value === "true"}
                    />
                </Box>
            );
        case "number":
            // Añadir si se necesita un valor por defecto
        default:
            return (
                <TextField
                    variant="filled"
                    label={t("filter.fields.value")}
                    onChange={(event) => {
                        const updatedFilters = [...comboFilters];
                        updatedFilters[index].value = event.target.value;
                        setComboFilters(updatedFilters);
                    }}
                    size="small"
                    defaultValue={value}
                    sx={{ paddingRight: 0.5 }}
                />
            );
    }
};